import {reqWithToken} from './requestHelper';

export async function getAll() {
    return (await reqWithToken('api/News/getAll')).data;
}

export async function get(id) {
    return (await reqWithToken(`api/News/get/${id}`,)).data;
}

export async function update(update) {
    return (await reqWithToken('api/News/update',{
        method: 'put',
        data: update
    })).data;
}

export async function remove(id) {
    return (await reqWithToken('api/News/remove',{
        method: 'delete',
        params: {id}
    })).data;
}

export async function getSystemNews(update) {
    return (await reqWithToken('api/News/getSystemNews',{
        method: 'put',
        data: update
    })).data;
}

export async function sendMail(data) {
    return (await reqWithToken('api/News/SendMail',{
        method: 'put',
        data: data
    })).data;
}

export async function getAllLog() {
    return (await reqWithToken('api/News/getAllLog')).data;
}

export async function getLog(id) {
    return (await reqWithToken(`api/News/getLog/${id}`,)).data;
}

export async function updateLog(update) {
    return (await reqWithToken('api/News/updateLog',{
        method: 'put',
        data: update
    })).data;
}

export async function getLogByInfo(update) {
    return (await reqWithToken('api/News/getLogByInfo',{
        method: 'put',
        data: update
    })).data;
}

export async function getChartByInfo(update) {
    return (await reqWithToken('api/News/getChartByInfo',{
        method: 'put',
        data: update
    })).data;
}